import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import PersonaCreatorSegmentsHeaderInfo from './PersonaCreatorSegmentsHeaderInfo';

class PersonaCreatorSegmentsHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      headerSegmentsData:
        this.props.segmentData !== undefined ? this.props.segmentData : [],
      // PersonaCreatorheaderVariance:
      //   this.props.PersonaCreatorheaderVariance !== undefined
      //     ? this.props.PersonaCreatorheaderVariance
      //     : [],
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.segmentData !== undefined) {
      this.setState({ headerSegmentsData: nextProps.segmentData });
    }

    if (!nextProps.segmentData) {
      this.setState({ headerSegmentsData: [] });
    } else if (this.props.segmentData !== nextProps.segmentData) {
      this.setState({ headerSegmentsData: nextProps.segmentData });
    }

    // if (nextProps.variance !== undefined) {
    //   this.setState({ PersonaCreatorheaderVariance: nextProps.varienceVal });
    // }
  }

  pcHeaderBackgroudCol = index => {
    let pcHeaderBackgroudColor = '';
    if (index === 0) {
      pcHeaderBackgroudColor = 'pcHeaderFirstSegmentBgColor';
    }
    if (index === 1) {
      pcHeaderBackgroudColor = 'pcHeaderSecondSegmentBgColor';
    }
    if (index === 2) {
      pcHeaderBackgroudColor = 'pcHeaderThirdSegmentBgColor';
    }
    return pcHeaderBackgroudColor;
  };

  render() {
    return (
      <div id="pdfpcSegmentHeader">
        <div className="row expanded header-margin" id="personaHeader">
          <div className="row fullwidth">
            <div
              className="row fullwidth demographic-detail-columns"
              id="pcSegmentHeader"
            >
              {!_.isEmpty(this.state.headerSegmentsData.segments) &&
                this.state.headerSegmentsData.segments.length > 0 &&
                this.state.headerSegmentsData.segments.map(
                  (segmentInfo, index) => (<div key={index}>
                    <div className="columns large-4 medium-4 small-4 pdfCreatorHeaderBorder">
                      <div
                        className={`row fullwidth demographic-header-border demographic-detail-columns ${
                          index === 0 ? 'triple-header-margin-left' : ''
                          } ${index === 2 ? '' : 'header-margin-right'}`}
                        id={this.pcHeaderBackgroudCol(index)}
                      >
                        <PersonaCreatorSegmentsHeaderInfo
                          headerSegmentDetail={segmentInfo}
                        />
                      </div>
                    </div>
                  </div>
                  ),
                )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

PersonaCreatorSegmentsHeader.propTypes = {
  //   loginResponse: PropTypes.shape({
  //     data: PropTypes.shape({
  //       uid: PropTypes.number,
  //       token: PropTypes.string,
  //     }),
  //   }),
  segmentData: PropTypes.shape({}),
};

function mapStateToProps(state) {
  return {
    segmentData: state.insight360.personaCreator.segments,
    // varianceVal: state.insight360.personaCreator.variance
    // personaCreator: state.insight360.personaCreator,
  };
}


export default connect(
  mapStateToProps,
  null,
  null,
  { forwardRef: true },
)(PersonaCreatorSegmentsHeader);
